// Seletores e abas de método de assinatura: a lista vem de signature_methods (GET /entity); aqui só valor -> rótulo.
const LABELS = {
  email: 'Email',
  icp: 'Certificado Digital',
  selfie: 'Selfie',
  whatsapp: 'WhatsApp',
};

// Listas de hoje, só para backend sem signature_methods no GET /entity (antes da US-008); apagar quando todos os ambientes tiverem
const LEGACY_SELECTOR_OPTIONS = [
  { value: 'email', label: 'Email' },
  { value: 'icp', label: 'Certificado Digital' },
  { value: 'selfie', label: 'Selfie' },
  { value: 'whatsapp', label: 'Whatsapp' },
  { value: 'sms', label: 'SMS' },
];

const LEGACY_TAB_OPTIONS = [
  { value: 'email', label: 'Email' },
  { value: 'selfie', label: 'Selfie' },
  { value: 'icp', label: 'ICP' },
];

const toOptions = (methods) => methods.map((value) => ({ value, label: LABELS[value] || value }));

export const signatureMethodOptions = (methods) => (methods ? toOptions(methods) : LEGACY_SELECTOR_OPTIONS);

export const signatureTabOptions = (methods) => (methods ? toOptions(methods) : LEGACY_TAB_OPTIONS);
